import React, { useEffect, useState } from "react";
import Portfolio from "./PortfolioSite";
export default function App() {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem("theme") === "light" ? "light" : "dark";
    } catch {
      return "dark";
    }
  });
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try {
      localStorage.setItem("theme", theme);
    } catch {
      /* Storage may be disabled. */
    }
  }, [theme]);
  return (
    <Portfolio
      theme={theme}
      toggleTheme={() => setTheme(theme === "dark" ? "light" : "dark")}
    />
  );
}
